import { useContext } from "react";
import useSWR from "swr";
import InventoryServiceContext from "../../providers/inventoryService-context";

const useFlowFieldListDistinctValues = (fieldName) => {
    const inventoryService = useContext(InventoryServiceContext);
    const {data, error} = useSWR("flow-field:" + fieldName, () => inventoryService.listFlowFieldOptions(fieldName));

    if (error) {
        console.log("Fetching flow field options for field " + fieldName + ", with as result: ", data, error);
    }
    if (data && data.data && data.data.listFlowFieldSearch) {
        return data.data.listFlowFieldSearch.items;
    }
    return data;
};

export default useFlowFieldListDistinctValues;
